// extracted by mini-css-extract-plugin
export default {"appStyles":"App_appStyles__-AgDg"};